import { ScanLine } from 'lucide-react';
import { Pressable, Text } from 'components/ui';

export const CardInputButton = ({ text, onPress, isActive }) => {
  return (
    <Pressable
      alignItems={'center'}
      backgroundColor={isActive ? 'feather.100' : 'white'}
      borderColor={isActive ? 'fieldBorder.200' : 'transparent'}
      borderRadius={'row'}
      borderWidth={1}
      color={'secondary.200'}
      display={'flex'}
      flex={1}
      flexDirection={'column'}
      gap={'14px'}
      onClick={onPress}
      px={'16px'}
      py={'24px'}
      textAlign={'center'}
      transition={'box-shadow .15s, border-color .15s'}
      _hover={{
        borderColor: 'fieldBorder.200',
        boxShadow: '0 3px 12px rgba(4, 51, 56, 0.07)',
      }}
    >
      <ScanLine size={52} strokeWidth={1.5} />

      <Text
        color={'secondary.500'}
        fontSize={'16px'}
        fontWeight={700}
        lineClamp={3}
      >
        {text}
      </Text>
    </Pressable>
  );
};

export default CardInputButton;
